import { exportCollectionOrders } from '@/api/collectionOrder';
import Spinner from '@/components/Spinner';
import { Button } from '@/components/ui/button';

import React, { useState } from 'react';

type Props = {};

const ExportCollection = (props: Props) => {
  const [loading, setLoading] = useState(false);

  const handleExportCollection = async () => {
    try {
      setLoading(true);
      const res = await exportCollectionOrders(); // Assuming this returns the CSV data as a Blob or plain text

      const blob = new Blob([res], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'collection_orders.csv'); // Set the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up the DOM

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handleExportCollection}
      className='bg-white space-x-2 px-3'
      variant={'outline'}
    >
      {loading ? (
        <Spinner />
      ) : (
        <>
          <img src='/assets/icons/printer.svg' alt='export' />
          <p>Export the schedule</p>
        </>
      )}
    </Button>
  );
};

export default ExportCollection;
